import { COMMERCE_LIBRARIES, UNKNOWN } from './index';
export var responsibleServiceIncludesCommerceLibraries = function responsibleServiceIncludesCommerceLibraries(responsibleService) {
  return responsibleService === COMMERCE_LIBRARIES || responsibleService === UNKNOWN;
};